var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prospect-info-container"},[_c('div',{staticClass:"prospect-info__title"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"prospect-info__content",class:_vm.customClass},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }